import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {DatasetAwareComponent, DataSetItem} from "../../input/dataset-aware.component";
import {FormsModule} from "@angular/forms";
import {isDefined, isMobile, runtimeEventManager} from "@wm/core";

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-search',
  hostClass: 'app-search input-group',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmSearch]',
  template: `
    <input [title]="query || ''" type="text" class="app-textbox form-control list-of-objs" [placeholder]="placeholder || ''"
           focus-target
           autocomplete="off"
           [(ngModel)]="query"
           [readonly]="readonly"
           [tabindex]="tabindex"
           [attr.name]="name"
           [attr.aria-label]="hint || 'Search field'">
    <input class="model-holder" [(ngModel)]="proxyModel" [required]="required" tabindex="-1" aria-hidden="true">
    <span *ngIf="_loadingItems" aria-hidden="true" class="fa fa-circle-o-notch fa-spin form-control-feedback"></span>
<!--    <span class="wi wi-close form-control-feedback clear-btn"></span>-->
    <span *ngIf="showsearchicon" class="input-group-addon" aria-label="search icon" [ngClass]="{'disabled': disabled}">
        <form>
            <button title="Search" [disabled]="disabled" class="app-search-button" type="submit">
                    <i class="app-icon {{searchiconclass}}"></i></button>
        </form>
    </span>
  `,
  providers: [
    provideAsWidgetRef(SearchComponent)
  ],
  exportAs: 'wmSearch',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: []
})
export class SearchComponent extends DatasetAwareComponent {
  static initializeProps = register('wm-search');

  public casesensitive: boolean;
  public searchkey: string;
  public queryModel: Array<DataSetItem> | string;
  public query = '';
  public limit: any;
  public showsearchicon: boolean = true;
  public minchars: number;
  public type: string;
  public navsearchbar: any;
  public debouncetime: number;
  public hint: string;
  public name: string;
  public placeholder: string;
  public _loadingItems: boolean;
  public override tabindex: number;
  public startIndex: number;
  public binddisplaylabel: string;
  public proxyModel: string;
  public required: boolean;
  public containerTarget: string;
  public searchiconclass: string;
  private liveWidgetUtils: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.liveWidgetUtils = runtimeEventManager.getService('LiveWidgetUtilsService')
  }

  override ngOnInit() {
    super.ngOnInit();
    this.showsearchicon = isDefined(this.showsearchicon) ? this.showsearchicon : (this.type === 'search');
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'datavalue':
        this.query = nv;
        break;
      case 'type':
        this.showsearchicon = (nv === 'search');
        let isAutocomplete = nv === 'autocomplete';
        this.widgetProps['searchon'].show = !isAutocomplete;
        this.widgetProps['searchiconclass'].show = !isAutocomplete;
        if (isDefined(ov)){
          runtimeEventManager.emit('set-markup-attr', {widgetId: this.widgetId, 'searchon': isAutocomplete ? '' : 'typing', 'searchiconclass': isAutocomplete ? '' : 'wm-sl-l sl-search'});
        }
        if (this.isMobileAutoComplete(this.type)) {
          this.widgetProps['showclear'].show = true;
          runtimeEventManager.emit('set-markup-attr', {widgetId: this.widgetId, 'showclear': true});
        }
        break;
    }
    super.onPropertyChange(key, nv, ov);
  }
  isMobileAutoComplete(type: string) {
    return type === 'autocomplete' && isMobile();
  }
  getCustomizedOptions(name: any, fields: any){
    return this.liveWidgetUtils.getCustomizedOptions(this, name, fields);
  }
}

